import { LocalStore } from '@/shared/lib/local-storage';

const state = {
  enableAnimations: new LocalStore('promo_').get('enable_animation', true),
};

const mutations = {
  SET_ENABLE_ANIMATIONS(state, enableAnimations) {
    state.enableAnimations = enableAnimations;
    new LocalStore('promo_').set('enable_animation', enableAnimations);
  },
};

const actions = {
  enableAnimations({ commit }) {
    commit('SET_ENABLE_ANIMATIONS', true);
  },
  disableAnimations({ commit }) {
    commit('SET_ENABLE_ANIMATIONS', false);
  },
};

const getters = {
  isAnimationsEnabled: (state) => state.enableAnimations,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
